import React, { useState } from "react";

function CaseItem({ c }) {
  const [open, setOpen] = useState(false);
  const detailId = `case-detail-${c.id}`;

  return (
    <article className={`case${open ? " is-open" : ""}`}>
      <div className="case-meta-col">
        <div className="case-number">§ {c.number}</div>
        <div className="case-domain">{c.domain}</div>
      </div>

      <div className="case-body">
        <div className="case-client">Client — {c.client}</div>
        <h3 className="case-title">{c.title}</h3>
        <p className="case-summary">{c.summary}</p>

        <button
          type="button"
          className="case-toggle"
          aria-expanded={open}
          aria-controls={detailId}
          onClick={() => setOpen((o) => !o)}
        >
          <span className="case-toggle-icon" aria-hidden="true" />
          {open ? "Collapse" : "Read the case study"}
        </button>

        <div id={detailId} className="case-detail">
          <div className="case-detail-col">
            <h4>The challenge</h4>
            <p>{c.challenge}</p>
          </div>

          <div className="case-detail-col">
            <h4>Technical scope</h4>
            <ul>
              {c.scope.map((s, i) => <li key={i}>{s}</li>)}
            </ul>
          </div>

          <div className="case-detail-col">
            <h4>Impact</h4>
            <ul>
              {c.impact.map((s, i) => <li key={i}>{s}</li>)}
            </ul>
          </div>

          <div className="case-tech">
            <span className="mono-label">Technologies</span>
            <div className="tag-row">
              {c.tech.map((t, i) => <span key={i} className="tag">{t}</span>)}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default function CaseStudies({ head, projects }) {
  if (!projects) return null;
  return (
    <section id="work" className="section">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">{head?.eyebrow}</span>
          <h2 className="display-2">{head?.title}</h2>
        </div>

        <div className="work-list">
          {projects.map((c) => <CaseItem key={c.id} c={c} />)}
        </div>
      </div>
    </section>
  );
}
